import DefaultRenderer from './default';

class sustainability extends DefaultRenderer {
	onEnter() {
		super.onEnter();
	}

	onLeave() {
		super.onLeave();
	}

	onEnterCompleted() {
		super.onEnterCompleted();
	}
}

export default sustainability;



// WEBPACK FOOTER //
// ./scripts/highway/renderers/sustainability.js